export const PartyColumns = (windowWidth) => {
  const columns = [
    {
      field: "ACCOUNT_NO",
      accessor: "ACCOUNT_NO",
      width: windowWidth <= 768 ? 80 : 80,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Acc. No.</div>,
    },
    {
      field: "NAME",
      accessor: "NAME",
      width: windowWidth <= 768 ? 200 : windowWidth <= 1024 ? 200 : 300,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Party Name</div>,
    },
    {
      field: "TAX_NUMBER",
      accessor: "TAX_NUMBER",
      width: windowWidth <= 768 ? 100 : 180,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>GST Number</div>,
    },
    {
      field: "MOBILE",
      accessor: "MOBILE",
      width: windowWidth <= 768 ? 100 : 120,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Mobile</div>,
    },
    {
      field: "ADDRESS",
      accessor: "ADDRESS",
      width: windowWidth <= 768 ? 130 : windowWidth <= 1024 ? 130 : 200,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Address</div>,
    },
    {
      field: "CITY",
      accessor: "CITY",
      width: windowWidth <= 768 ? 130 : 130,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>City</div>,
    },
    {
      field: "STATE",
      accessor: "STATE",
      width: windowWidth <= 768 ? 130 : 130,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>State</div>,
    },
    {
      field: "COUNTRY",
      accessor: "COUNTRY",
      width: windowWidth <= 768 ? 130 : 130,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Country</div>,
    },
  ];

  const mobileCol = [
    {
      field: "ACCOUNT_NO",
      accessor: "ACCOUNT_NO",
      width: 60,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Acc. No.</div>,
    },
    {
      field: "NAME",
      accessor: "NAME",
      width: windowWidth <= 768 ? 150 : windowWidth <= 1024 ? 100 : 300,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Party Name</div>,
    },
    {
      field: "MOBILE",
      accessor: "MOBILE",
      width: windowWidth <= 768 ? 100 : 120,
      headerAlign: "center",
      headerClassName: "super-app-theme--header",
      renderHeader: (params) => <div style={{ fontSize: 13 }}>Mobile</div>,
    },
  ];

  return windowWidth > 764 ? columns : mobileCol;
};
